import { Product } from "@common/product";

export interface ProductsState {
    products: Product[];
    totalElements: number;
    loading: boolean;
    error: any;
}

export const initialState: ProductsState = {
    products: [],
    totalElements: 0,
    loading: false,
    error: null
};